<template>
    <!-- :style="{ height: height || '75%', width: '100%', 'background-color': '#f5f5f5', 'overflow-y': 'scroll' }" -->
    <!-- :overlay-style="{ 'background-color': '#f5f5f5' }" -->
    <van-popup v-model="showPopup" position="bottom" style="max-height: 85%;" round @open="popupOpen" @opened="popupOpened" @close="pupupClose" @closed="pupupClosed" :transition-appear="true" :overlay="true">
        <div class="van-picker">
            <div class="van-picker__toolbar my-select-head">
                <button type="button" class="van-picker__cancel" @click="hide">取消</button>
                <div class="van-ellipsis van-picker__title">{{ title || "" }}</div>
                <button type="button" class="van-picker__confirm" @click="confirm">确认</button>
            </div>
            <div class="userDiv">
                <template v-if="list && list.length > 0">
                    <van-cell-group style="width: 95%">
                        <van-cell v-for="(item, index) in list" clickable :key="item" :title="item" @click="select(item, index)">
                            <template #right-icon>
                                <van-icon v-show="verifySelect(item)" name="success" color="#533afd" />
                            </template>
                        </van-cell>
                    </van-cell-group>
                </template>
                <van-empty v-else image="error" description="暂无数据" />
            </div>
        </div>
    </van-popup>
</template>

<script>
export default {
    name: "MySelect",
    components: {},
    // <my-select :show.sync="showSelectUser" v-model="selectList" @confirm="confirmActionListFun" />

    // show 来控制显隐
    // value 默认选中动作列表
    // confirm 选中动作列表接收函数 参数为选中动作列表
    props: ["show", "list", "value", "title"],
    data() {
        return {
            selectList: this.value || [],
            showPopup: false,
        };
    },
    computed: {},
    watch: {
        selectList(val) {
            // if (this.getActionIds(val) == this.getActionIds(this.value)) {
            //     return;
            // }
            // this.$emit("input", val);
            //console.log("selectList", val);
        },
        value(val) {
            //console.log("value", val);
        },
        show(val) {
            //console.log("show", val);
            if (this.showPopup != val) {
                this.showPopup = val;
            }
        },
        showPopup(val) {
            //console.log("showPopup", val);
            if (this.show != val) {
                this.$emit("update:show", val);
            }
        }
    },
    created() {
        window.mySelectVue = this;
    },
    methods: {
        popupOpen() {
            this.$emit("open");
        },
        popupOpened() {
            this.$emit("opened");
        },
        pupupClose() {
            this.$emit("close");
        },
        pupupClosed() {
            this.$emit("closed");
        },
        verifySelect(item) {
            if(typeof(item) == "string"){
                return this.selectList.indexOf(item) > -1;
            }else {
                return item.checked;
            }
        },
        select(item, itemIndex) {
            var checked  = true;
            if(typeof(item) == "string"){
                let fI = this.selectList.indexOf(item);
                if(fI > -1){
                    checked  = false;
                    this.selectList.splice(fI, 1);
                }else {
                    checked  = true;
                    this.selectList.push(item);
                }
            }else {
                item.checked = !item.checked;
                if(item.checked){
                    checked  = false;
                    this.selectList.push(item);
                }else{
                    checked  = true;
                    let fI = this.selectList.indexOf(item);
                    if(fI > -1){
                        this.selectList.splice(fI, 1);
                    }
                }
            }
            this.$emit("change",checked, this.selectList, item, itemIndex);
        },
        confirm() {
            this.$emit("input", this.selectList);
            this.$emit("confirm", this.selectList);
            this.hide();
        },
        hide(e) {
            this.$emit("update:show", false);
        },
        back() {
            if (this.show) {
                this.hide();
                return false;
            } else {
                this.hide();
                return true;
            }
        },
    },
};
</script>

<style scoped>
.my-select-head{
    position: relative;
    top: 0px;
    width: 100%;
}
.userDiv {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
    width: 100%;
    text-align: left;
    overflow-y: auto;
    max-height: 85vh;
}

</style>
